<template>
  <div>
    <div id="richText" style="height: 400px; background-color: #fff"></div>
  </div>
</template>

<script lang="tsx">
import { ref, onMounted, onUnmounted, watch, defineComponent } from "vue";
import type { PropType, ExtractPropTypes, SetupContext } from "vue";
import E from "wangeditor";
import { buildProps } from "../../utils/props";
// Editor组件props定义
const EditorProps = buildProps({
  modelValue: {
    type: String,
    default: "",
  },
});

type EditorPropsType = ExtractPropTypes<typeof EditorProps>;
export default defineComponent({
  props: EditorProps,
  components: {},

  setup(props: EditorPropsType, contents: SetupContext): any {
    // 编辑器实例，必须用 shallowRef，重要！

    const phoneEditor: any = ref("");

    let nowValue = "" + props.modelValue;
    onMounted(() => {
      phoneEditor.value = new E("#richText");
      // 上传图片到服务器，base64形式
      phoneEditor.value.config.uploadImgShowBase64 = true;
      // 隐藏网络图片
      phoneEditor.value.config.showLinkImg = false;
      // 创建一个富文本编辑器
      phoneEditor.value.create();
      // 富文本内容

      phoneEditor.value.txt.html(nowValue);
      phoneEditor.value.config.onchange = (newHtml: string): void => {
        nowValue = newHtml;
        contents.emit("update:modelValue", newHtml);
      };
    });
    watch(
      () => props.modelValue,
      (newValue: string): void => {
        console.log(newValue, nowValue);
        console.log(phoneEditor.value.txt);
        if (newValue != nowValue) {
          phoneEditor.value.txt.html(newValue);
          nowValue = newValue;
        }
      }
    );
    onUnmounted(() => {
      phoneEditor.value.destroy();
      phoneEditor.value = "";
      nowValue = "";
    });
    return {
      nowValue,
    };
  },
});
</script>
